module.exports = __webpack_public_path__ + "img/glasbreak-sensor-sm.938b2e38.svg";